import { gql } from 'apollo-angular';

export const GET_MY_UNREAD_NOTIFICATIONS = gql`
  query MyUnreadNotifications($pageableParam: PageableParamInput!) {
    myUnreadNotifications(pageableParam: $pageableParam) {
      first
      hasContent
      hasNext
      hasPrevious
      last
      number
      numberOfElements
      size
      totalElements
      totalPages
      content {
        actionTaken
        actionTakenBy
        active
        businessKey
        businessType
        comment
        companyId
        createdAt
        id
        message
        read
        readAt
        recipientEmail
        recipientName
        recipientUserId
        stageCode
        taskStatus
        title
        uuid
        updatedAt
        workflowInstanceId
        workflowStatus
      }
    }
  }
`;

export const GET_MY_NOTIFICATIONS = gql`
  query MyNotifications($pageableParam: PageableParamInput) {
    myNotifications(pageableParam: $pageableParam) {
      first
      hasContent
      hasNext
      hasPrevious
      last
      number
      numberOfElements
      size
      totalElements
      totalPages
      content {
        actionTaken
        actionTakenBy
        active
        businessKey
        businessType
        comment
        companyId
        createdAt
        deletedAt
        id
        message
        read
        readAt
        recipientEmail
        recipientName
        recipientUserId
        stageCode
        taskStatus
        title        
        uuid
        workflowInstanceId
        workflowStatus
        workflowTaskId
      }
    }
  }
`;

export const GET_MY_UNREAD_NOTIFICATION_COUNT = gql`
  query MyUnreadNotificationCount {
    myUnreadNotificationCount
  }
`;

export const MARK_ALL_MY_NOTIFICATIONS_AS_READ = gql`
  mutation MarkAllMyNotificationsAsRead {
    markAllMyNotificationsAsRead {
      code
      data
      dataList
      extras
      fieldsErrors
      message
      status
    }
  }
`;

export const MARK_NOTIFICATION_AS_READ = gql`
  mutation MarkNotificationAsRead($uuid: UUID!) {
    markNotificationAsRead(uuid: $uuid) {
      code
      extras
      fieldsErrors
      message
      status
      data {
        active
        businessKey
        businessType
        comment
        companyId
        id
        message
        read
        uuid
      }
    }
  }
`;
